import dynamic from 'next/dynamic'
import { ComponentProps } from 'react'
import { useQuery } from 'react-query'
import { getIndexName } from 'utils/instantsearch'
const ReactInstantSearch = dynamic(
  () => import('react-instantsearch').then(m => m.InstantSearch),
  { ssr: false }
)

type Props = {
  children: React.ReactNode
  stage?: string
  index?: 'search' | 'filter'
} & Omit<
  ComponentProps<typeof ReactInstantSearch>,
  'searchClient' | 'indexName'
>

export const InstantSearch = ({
  children,
  index = 'search',
  ...props
}: Props) => {
  const indexName = getIndexName(index)

  const { data: searchClient } = useQuery(
    'algolia-search-client',
    async () => {
      const { default: algoliasearch } = await import('algoliasearch')
      return algoliasearch(
        process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || '',
        process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY || ''
      )
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  )

  if (!searchClient) return null

  return (
    <ReactInstantSearch
      {...props}
      searchClient={searchClient}
      indexName={indexName}
    >
      {children}
    </ReactInstantSearch>
  )
}
